import { useParams } from 'react-router-dom';
import type { IStepWizardChildProps } from 'components/common/StepWizard';
import Loading from 'components/common/Loading';
import CO2CalculatorResult from 'components/calculators/CO2CalculatorResult';
import useGetCO2Calculations from 'hooks/co2-calculator/useCO2Calculations';
import requireValue from 'utils/requireValue';

type TCO2StatusSecondStepProps = Partial<
  Pick<IStepWizardChildProps, 'nextStep' | 'previousStep' | 'currentStep'>
>;

const CO2StatusSecondStep = ({
  nextStep,
  previousStep,
  currentStep,
}: TCO2StatusSecondStepProps) => {
  const { id: projectId } = useParams<{ id?: string }>();
  // The calculators are rendered on the project routes (`/project/:id/...`) only.
  const [co2Calculations, loading] = useGetCO2Calculations(requireValue(projectId, 'id'));

  if (loading) {
    return <Loading size={50} />;
  }

  return <CO2CalculatorResult {...{ previousStep, nextStep, co2Calculations, currentStep }} />;
};

export default CO2StatusSecondStep;
